import { translate as t } from '@thoughtspot/i18n';
import { ErrorCode } from '@thoughtspot/radiant-react/widgets/alert/alert-constants';
export var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes["GENERIC_ERROR"] = "GENERIC_ERROR";
    ErrorTypes["CHART_INITIALIZATION_ERROR"] = "CHART_INITIALIZATION_ERROR";
    ErrorTypes["CHART_RENDER_ERROR"] = "CHART_RENDER_ERROR";
    ErrorTypes["CHART_RENDER_TIMEOUT"] = "CHART_RENDER_TIMEOUT";
    ErrorTypes["IFRAME_RENDER_ERROR"] = "IFRAME_RENDER_ERROR";
    ErrorTypes["INIT_INVALID_CONFIG_ERROR"] = "INIT_INVALID_CONFIG_ERROR";
    ErrorTypes["INIT_CONFIG_IMPOSSIBLE_ERROR"] = "INIT_CONFIG_IMPOSSIBLE_ERROR";
    ErrorTypes["INVALID_CUSTOM_ACTION_ERROR"] = "INVALID_CUSTOM_ACTION_ERROR";
    ErrorTypes["MESSAGE_TIMEOUT_ERROR"] = "MESSAGE_TIMEOUT_ERROR";
    ErrorTypes["VISUAL_PROPS_VALIDATION_ERROR"] = "VISUAL_PROPS_VALIDATION_ERROR";
    ErrorTypes["DATA_LIMIT_EXCCED_ERROR"] = "DATA_LIMIT_EXCCED_ERROR";
    ErrorTypes["CHART_CONFIG_VALIDATION_ERROR"] = "CHART_CONFIG_VALIDATION_ERROR";
})(ErrorTypes || (ErrorTypes = {}));
export function customChartErrorTemplate() {
    return {
        [ErrorTypes.VISUAL_PROPS_VALIDATION_ERROR]: {
            errorTitle: t('customChartErrorMessage.VISUAL_PROPS_VALIDATION_ERROR.title'),
            errorDescription: t('customChartErrorMessage.VISUAL_PROPS_VALIDATION_ERROR.description'),
            errorDetail: t('customChartErrorMessage.VISUAL_PROPS_VALIDATION_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.VISUAL_PROPS_VALIDATION_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.CHART_CONFIG_VALIDATION_ERROR]: {
            errorTitle: t('customChartErrorMessage.CHART_CONFIG_VALIDATION_ERROR.title'),
            errorDescription: t('customChartErrorMessage.CHART_CONFIG_VALIDATION_ERROR.description'),
            errorDetail: t('customChartErrorMessage.CHART_CONFIG_VALIDATION_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.CHART_CONFIG_VALIDATION_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.GENERIC_ERROR]: {
            errorTitle: t('customChartErrorMessage.UNKNOWN_ERROR.title'),
            errorDescription: t('customChartErrorMessage.UNKNOWN_ERROR.description'),
            errorDetail: t('customChartErrorMessage.UNKNOWN_ERROR.description'),
            errorCode: ErrorCode.LOCAL_GENERIC_NOT_FOUND,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.UNKNOWN_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.CHART_INITIALIZATION_ERROR]: {
            errorTitle: t('customChartErrorMessage.CHART_INIT_FAILED.title'),
            errorDescription: t('customChartErrorMessage.CHART_INIT_FAILED.description'),
            errorDetail: t('customChartErrorMessage.CHART_INIT_FAILED.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.CHART_INIT_FAILED.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.CHART_RENDER_ERROR]: {
            errorTitle: t('customChartErrorMessage.CHART_RENDER_FAILED.title'),
            errorDescription: t('customChartErrorMessage.CHART_RENDER_FAILED.description'),
            errorDetail: t('customChartErrorMessage.CHART_RENDER_FAILED.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.CHART_RENDER_FAILED.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.CHART_RENDER_TIMEOUT]: {
            errorTitle: t('customChartErrorMessage.CHART_RENDER_TIMEOUT.title'),
            errorDescription: t('customChartErrorMessage.CHART_RENDER_TIMEOUT.description'),
            errorDetail: t('customChartErrorMessage.CHART_RENDER_TIMEOUT.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.CHART_RENDER_TIMEOUT.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.MESSAGE_TIMEOUT_ERROR]: {
            errorTitle: t('customChartErrorMessage.MESSAGE_TIMEOUT_ERROR.title'),
            errorDescription: t('customChartErrorMessage.MESSAGE_TIMEOUT_ERROR.description'),
            errorDetail: t('customChartErrorMessage.MESSAGE_TIMEOUT_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.MESSAGE_TIMEOUT_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.IFRAME_RENDER_ERROR]: {
            errorTitle: t('customChartErrorMessage.IFRAME_RENDER_ERROR.title'),
            errorDescription: t('customChartErrorMessage.IFRAME_RENDER_ERROR.description'),
            errorDetail: t('customChartErrorMessage.IFRAME_RENDER_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.IFRAME_RENDER_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.INIT_INVALID_CONFIG_ERROR]: {
            errorTitle: t('customChartErrorMessage.INIT_INVALID_CONFIG_ERROR.title'),
            errorDescription: t('customChartErrorMessage.INIT_INVALID_CONFIG_ERROR.description'),
            errorDetail: t('customChartErrorMessage.INIT_INVALID_CONFIG_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.INIT_INVALID_CONFIG_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.INIT_CONFIG_IMPOSSIBLE_ERROR]: {
            errorTitle: t('customChartErrorMessage.INIT_CONFIG_IMPOSSIBLE_ERROR.title'),
            errorDescription: t('customChartErrorMessage.INIT_CONFIG_IMPOSSIBLE_ERROR.description'),
            errorDetail: t('customChartErrorMessage.INIT_CONFIG_IMPOSSIBLE_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.INIT_CONFIG_IMPOSSIBLE_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.INVALID_CUSTOM_ACTION_ERROR]: {
            errorTitle: t('customChartErrorMessage.INVALID_CUSTOM_ACTION_ERROR.title'),
            errorDescription: t('customChartErrorMessage.INVALID_CUSTOM_ACTION_ERROR.description'),
            errorDetail: t('customChartErrorMessage.INVALID_CUSTOM_ACTION_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.INVALID_CUSTOM_ACTION_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.DATA_LIMIT_EXCCED_ERROR]: {
            errorTitle: t('customChartErrorMessage.DATA_LIMIT_EXCCED_ERROR.title'),
            errorDescription: t('customChartErrorMessage.DATA_LIMIT_EXCCED_ERROR.description'),
            errorDetail: t('customChartErrorMessage.DATA_LIMIT_EXCCED_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.DATA_LIMIT_EXCCED_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
    };
}
export function tsHostedCustomChartErrorMessagesMap() {
    return {
        [ErrorTypes.INIT_CONFIG_IMPOSSIBLE_ERROR]: {
            errorTitle: t('customChartErrorMessage.INIT_CONFIG_IMPOSSIBLE_ERROR.title'),
            errorDescription: t('customChartErrorMessage.INIT_CONFIG_IMPOSSIBLE_ERROR.description'),
            errorDetail: t('customChartErrorMessage.INIT_CONFIG_IMPOSSIBLE_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: t('customChartErrorMessage.INIT_CONFIG_IMPOSSIBLE_ERROR.ErrorMsgCode'),
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.GENERIC_ERROR]: {
            errorTitle: t('tsHostedCustomChartErrorMessages.UNKNOWN_ERROR.title'),
            errorDescription: t('tsHostedCustomChartErrorMessages.UNKNOWN_ERROR.description'),
            errorDetail: t('tsHostedCustomChartErrorMessages.UNKNOWN_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: '',
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.DATA_LIMIT_EXCCED_ERROR]: {
            errorTitle: t('tsHostedCustomChartErrorMessages.DATA_LIMIT_EXCCED_ERROR.title'),
            errorDescription: t('tsHostedCustomChartErrorMessages.DATA_LIMIT_EXCCED_ERROR.description'),
            errorDetail: t('tsHostedCustomChartErrorMessages.DATA_LIMIT_EXCCED_ERROR.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: '',
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
        [ErrorTypes.CHART_RENDER_TIMEOUT]: {
            errorTitle: t('tsHostedCustomChartErrorMessages.CHART_RENDER_TIMEOUT.title'),
            errorDescription: t('tsHostedCustomChartErrorMessages.CHART_RENDER_TIMEOUT.description'),
            errorDetail: t('tsHostedCustomChartErrorMessages.CHART_RENDER_TIMEOUT.description'),
            errorCode: ErrorCode.LOCAL_VISUALIZATION,
            shouldShowErrorImage: true,
            ErrorMsgCode: '',
            shouldShowErrorDetail: true,
            shouldShowErrorDescription: true,
        },
    };
}
//# sourceMappingURL=chart-error.helper.js.map